import { validatePaymentNotification } from "../PaymentNotificationParameterForm";
import { validateSalesNotification } from "../SalesNotificationParameterForm";
import { validateSalesPartition } from "../SalesPartitionParameterForm";

const printParameterFormFunctions = {
  '3': validateSalesNotification,
  '5': validateSalesPartition,
  '6': validatePaymentNotification,
  '13': validateSalesNotification,
}

/** 印刷パラメータ画面の入力バリデートを行う */
const validatePrintParameterForm = (printSetting, formValue) => {
  const validateFunction = printParameterFormFunctions[printSetting.Value.reportTypeId];
  
  if (!validateFunction) {
    return false;
  }

  return validateFunction(formValue);
}

export default validatePrintParameterForm;